// The section «Parlamento» of a Coro document's page, presentational: the
// type, the chamber, the committee and its meeting as label-value rows, the
// links the document offers (the bulletin's PDF, the act's card) as rows
// with «Apri», and the source's updates as the last row. Every element is
// one the page already has:
//   section label   SectionLabel, NewsReader.tsx:91-97 («Allegati», «Iter»)
//   rows            ROW_CLASS, NewsReader.tsx:100 (the line of «Fonti eliminate», panels.tsx:231-238, without its indent)
//   «Apri»          the file row's link, NewsReader.tsx:117-126 (STATUS_BUTTON_CLASS, PanelStatus.tsx:4-5)
// The data comes ready from the page (toParliamentFacts): nothing here calls the api.
import { buttonVariants } from "@heroui/react";

import type { ParliamentFacts as Facts } from "../../features/parliament/adapt";
import { ROW_CLASS, SectionLabel } from "../news/NewsReader";
import { STATUS_BUTTON_CLASS } from "../PanelStatus";

export const PARLIAMENT_SECTION = "Parlamento";
const SECTION_ID = "news-parliament";

export function ParliamentFacts({ facts, links, update }: Facts) {
  return (
    <section aria-labelledby={SECTION_ID} className="flex flex-col">
      <SectionLabel id={SECTION_ID}>{PARLIAMENT_SECTION}</SectionLabel>
      <dl>
        {facts.map((fact) => (
          <div key={fact.label} className={`flex gap-2.5 ${ROW_CLASS}`}>
            <dt className="shrink-0">{fact.label}</dt>
            <dd className="min-w-0 break-words text-foreground">{fact.value}</dd>
          </div>
        ))}
      </dl>
      {links.length > 0 && (
        <ul>
          {links.map((link) => (
            <li key={link.href} className={`flex items-center justify-between gap-2.5 ${ROW_CLASS}`}>
              <span className="min-w-0 break-words">{link.label}</span>
              <a
                href={link.href}
                target="_blank"
                rel="noreferrer"
                className={`${buttonVariants({ size: "sm" })} shrink-0 ${STATUS_BUTTON_CLASS}`}
              >
                Apri
              </a>
            </li>
          ))}
        </ul>
      )}
      {update && <p className={ROW_CLASS}>{update}</p>}
    </section>
  );
}
